import React, { useEffect } from 'react'

import EnterprisePlaylistService from './Service'

import { useServiceState, useNotification } from 'helpers'

import { IEnterprisePlaylistProviderProps } from './Interfaces'

const Provider: React.FC<IEnterprisePlaylistProviderProps> = ({ children, enterpriseId, playlistCode }) => {
  const state = useServiceState(EnterprisePlaylistService)
  const { emitError } = useNotification()

  useEffect(() => {
    async function loadInfo(enterprise: string, code: string) {
      const error = await EnterprisePlaylistService.loadPlaylistData(enterprise, code)

      if (error) {
        emitError(error)
      }
    }

    if (enterpriseId && playlistCode) {
      loadInfo(enterpriseId, playlistCode)
    }
  }, [enterpriseId, playlistCode])

  return (
    <React.Fragment>
      {children({
        state
      })}
    </React.Fragment>
  )
}

export default Provider
